import { request } from './client';

export function listProducts({ filter = {}, sort = {}, pagination = {} } = {}) {
  return request('/api/product/v1/products/list', {
    method: 'POST',
    body: JSON.stringify({ filter, sort, pagination }),
  });
}

export function getProduct(id) {
  return request(`/api/product/v1/products/${id}`);
}

export const PRODUCT_SORT = {
  RELEVANCE: {
    sort_by: 'PRODUCT_SORT_BY_RELEVANCE',
    sort_order: 'SORT_ORDER_DESC',
  },
  NAME_ASC: {
    sort_by: 'PRODUCT_SORT_BY_NAME',
    sort_order: 'SORT_ORDER_ASC',
  },
  NAME_DESC: {
    sort_by: 'PRODUCT_SORT_BY_NAME',
    sort_order: 'SORT_ORDER_DESC',
  },
  PRICE_ASC: {
    sort_by: 'PRODUCT_SORT_BY_PRICE',
    sort_order: 'SORT_ORDER_ASC',
  },
  PRICE_DESC: {
    sort_by: 'PRODUCT_SORT_BY_PRICE',
    sort_order: 'SORT_ORDER_DESC',
  },
  NEW: {
    sort_by: 'PRODUCT_SORT_BY_UPDATED_AT',
    sort_order: 'SORT_ORDER_DESC',
  },
};
